import React from 'react';

export function ProjectCostsHeader() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-3 rounded-md border border-slate-100 ">
      <div className="flex flex-wrap items-center gap-3">
        {/* Khoảng thời gian */}
        <div className="flex items-center gap-2 h-9 px-3 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 cursor-pointer hover:bg-white transition-all font-normal">
          <span>01/04/2024 - 30/09/2024</span>
          <i className="ri-calendar-line text-slate-400" />
        </div>

        <FilterSelect placeholder="Tất cả loại chi phí" />
        <FilterSelect placeholder="Tất cả trạng thái" />

        <button className="h-9 px-4 rounded-md border border-slate-200 bg-white flex items-center gap-2 text-xs lg:text-sm font-normal text-slate-600 hover:bg-slate-50 transition-all">
          <i className="ri-filter-3-line" />
          <span>Bộ lọc</span>
        </button>
      </div>

      <div className="flex items-center gap-2">
        <button className="h-9 px-3 rounded-md border border-slate-200 bg-white text-xs lg:text-sm font-normal text-slate-600 hover:bg-slate-50 transition-all flex items-center gap-2">
          <i className="ri-download-2-line" />
          <span>Xuất báo cáo</span>
        </button>
        <button className="h-9 px-4 rounded-md bg-emerald-600 text-white flex items-center gap-2 text-xs lg:text-sm font-normal hover:bg-emerald-700 transition-all  shadow-emerald-100">
          <i className="ri-add-line" />
          <span>Thêm chi phí</span>
        </button>
      </div>
    </div>
  );
}

function FilterSelect({ placeholder }: { placeholder: string }) {
  return (
    <div className="relative group min-w-[150px]">
      <select className="appearance-none w-full h-9 pl-3 pr-8 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 focus:outline-none focus:border-emerald-500 transition-all cursor-pointer font-normal">
        <option value="">{placeholder}</option>
      </select>
      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 group-hover:text-slate-600 pointer-events-none" />
    </div>
  );
}
